'use strict';

angular.module('feedController', [])

.controller('FeedController', ['appInfo', '$scope', '$rootScope', '$log', '$location', '$window', '$q', '$interval', '$timeout', 'PropertyService', 'SellerService', 'ContactService', 'AgentService', 'FeedService'
    ,function (appInfo, $scope, $rootScope, $log, $location, $window, $q, $interval, $timeout, PropertyService, SellerService, ContactService, AgentService, FeedService) {
    var ekey = $rootScope.currentUser.authdata;

    $scope.page = 'news';
    $scope.polling = false;
    $scope.newItems = false;

    // $rootScope.header.show = false;

    $scope.feedServ = new FeedService.Feed;

    var checkItemExists = function(item) {
        var itemExists = false;
        angular.forEach($scope.feedServ.items, function(feedItem){
            if(item.id !== feedItem.id) {
                itemExists = true;
            }
        });

        return itemExists;
    }


    $scope.showNewItems = function() {
        $window.scrollTo(0, angular.element('.feed').offsetTop);  
        $scope.newItems = !$scope.newItems;
    }

    var init = function() {
        $scope.feedServ.nextPage();
    };

    init();

}]);